import { clearAllIDBStores } from 'helper/LearningSpaceServices/IndexedDBHelper';
import { user } from './currentUser';
import { blockUserInteraction } from './blockUserInteractionHelper';
import { saveAllDSOsToS3 } from './saveAllDSOsToS3';
// import { removeATACookie } from './setOrganizationCookies';
// import request from './NetworkLayer';
import * as databaseLock from './lock';
// import { saveUrlForRedirect } from '../login/helper/urlHandler';

// To clear locally stored wistia player playbackrate
const clearWistiaPlaybackRate = () => {
  localStorage.removeItem('wistiaPlayerPlaybackRate');
};

const clearVideosCurrentTime = () => {
  if (user.id()) {
    localStorage.removeItem(`${user.id()}_mediaDuration`);
  }
};

export function deleteCookies() {
  // Delete all cookies (EXCEPT user_id and companyId)
  document.cookie.split(';').forEach(c => {
    if (c.trim().startsWith('user_id=') || c.trim().startsWith('companyId')) {
      return;
    }
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

export const clearUserData = async clearIndexDB => {
  blockUserInteraction(true);
  await databaseLock.acquire();
  clearVideosCurrentTime();

  await saveAllDSOsToS3();
  deleteCookies();

  if (clearIndexDB === true) {
    await clearAllIDBStores();
  }
  // IMP: Disabled clearing all IDB stores on Logout, clearing it on Login
  // await clearAllIDBStores();

  await databaseLock.unlock();
  blockUserInteraction(false);

  // To clear locally stored wistia player playbackrate
  clearWistiaPlaybackRate();
};
